import * as requests from '../api-request'
import getToken from '../get-token'

export const getPublicScriptOTP = async (data = {}, token) => {
  token = token || (await getToken())
  const queryString = new URLSearchParams(data)
  return requests.toJSON('GET', `script/access/script_view?${queryString}`, data, token)
}

export const getSharedScriptData = async (data) => {
  return requests.toJSON('POST', 'script/access/script_view_with_otp', data)
}

export const getSharedInfo = async (data, token) => {
  token = token || (await getToken())
  if (!token) {
    return
  }
  const queryString = requests.createQueryString(data)
  return requests.toJSON('GET', `script/access/details?${queryString}`, {}, token)
}

export const saveSharedInfo = async (data, token) => {
  token = token || (await getToken())
  return requests.toJSON('POST', 'script/access/details', data, token)
}

export const saveSharedScriptComment = async (data, token) => {
  token = token || (await getToken())
  if (!token) {
    return
  }
  return requests.toJSON('POST', 'script/access/save_shared_comment', data, token)
}

export const deleteSharedComment = async (data, token) => {
  token = token || (await getToken())
  return requests.toJSON('POST', 'script/access/delete_shared_comment', data, token)
}

export const updateBlock = async (data, token) => {
  token = token || (await getToken())
  if (!token) {
    return
  }
  return requests.toJSON('POST', 'script/access/update_block_text', data, token)
}
